<template>
    <div class="text-center">
        <v-bottom-sheet persistent v-model="sheetShown" inset scrollable>
            <!-- >>> Form, Fields -->
            <v-card>
                <v-card-title>
                    <v-toolbar v-if="editorMode === 'relocate'" color="#FEDE86">

                        <v-toolbar-title class="mb-0 font-weight-medium" style="color:#333;font-size:1.2em">Relocate Crew</v-toolbar-title>

                    </v-toolbar>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="#333" v-bind="attrs" v-on="on">
                                mdi-information
                            </v-icon>
                        </template>
                        <span>This relocates every Crewmember to a new Crew.<br /> The old Crew will remain.</span>
                    </v-tooltip>
                </v-card-title>

                <v-card-text style="height:800px;margin-top:24px;">
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-container>
                            <v-stepper non-linear>
                                <!-- >>> Stepper Header -->
                                <v-stepper-header>
                                    <v-stepper-step
                                        editable
                                        step="1">
                                        General
                                    </v-stepper-step>
                                </v-stepper-header>
                                <!-- <<< Stepper Header -->


                                <!-- >>> General -->
                                <v-stepper-content
                                    step="1"
                                    ref="stepperContent1">
                                    <!-- >>> Row - Crew Information -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Add a Crew</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-text-field
                                                        v-model="input_CrewName"
                                                        name="input_CrewName"
                                                        :rules ="[
                                                            rules.req(input_CrewName),
                                                            rules.min(2, input_CrewName),
                                                            rules.max(50, input_CrewName)
                                                        ]"
                                                        maxlength="50"
                                                        counter
                                                        clearable>
                                                        <template v-slot:label>
                                                            <p>
                                                            Name of Crew <span style="color: red; font-size: 1.4rem;">*</span>
                                                            </p>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-select
                                                        v-model="input_Aircraft"
                                                        :rules ="[
                                                            rules.req(input_Aircraft),
                                                        ]"
                                                        :items="editorMode === 'create' || editorMode === 'relocate' ? get_AircraftConfigs.filter(aircraft => aircraft.active === true) : get_AircraftConfigs"
                                                        item-text="code"
                                                        item-value="id">
                                                        <template v-slot:label>
                                                            Aircraft <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-select
                                                        v-model="input_Base"
                                                        :rules ="[
                                                            rules.req(input_Base),
                                                        ]"
                                                        :items="get_Bases_Filtered"
                                                        item-text="aptCode"
                                                        item-value="idAirport">
                                                        <template v-slot:label>
                                                            Base <span style="color: red; font-size: 1.4rem;">*</span>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Crew Information -->

                                    <!-- >>> Row - Description -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Descripton</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <v-textarea
                                                v-model="input_Remark"
                                                :rules="[
                                                    rules.max(200, input_Remark)
                                                ]"
                                                name="input_Remark"
                                                label="Remark"
                                                auto-grow
                                                maxlength="200"
                                                counter
                                                clearable
                                                value="">
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Description -->
                                </v-stepper-content>
                                <!-- <<< General -->

                            </v-stepper>
                        </v-container>
                    </v-form>

                    <v-container>
                            <v-card elevation="2">
                                    <v-expansion-panels accordion>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header class="pl-5 pt-2 font-weight-medium" style="font-size:1.2em;color:#333;">Crew</v-expansion-panel-header>
                                            <v-expansion-panel-content class="px-5">
                                                <p v-for="(member, i) in get_MemberOnCrew.crew" :key="member.contract3Code" style="display:inline;">
                                                    {{ member.contract3Code }}{{ i !== get_MemberOnCrew.crew.length - 1 ? ', ' : '' }}
                                                </p>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                        </v-expansion-panels>
                            </v-card>
                    </v-container>

                </v-card-text>


                <!-- >>> Action Buttons - Bottom -->
                <v-card-actions>
                    <p v-if="editorMode === 'update'" class="mb-0 ml-7 font-weight-medium">Current Crew: {{ actualCrewName }}</p>


                    <!-- >>> Second Leg -->
                    <div v-if="editorMode === 'relocate'" class="ml-7" style="display:flex;flex-direction:column;">
                        <p style="color: #92949C; font-size: 0.8rem;" class="mb-1">
                            Current Crew
                        </p>
                        <div style="display: flex; flex-direction: row; align-items: start;">
                            <div style="display: flex; flex-direction: row;">
                                <v-icon class="mr-1">mdi-account-group</v-icon>
                                <div class="mr-8" style="display:flex;flex-direction:row;">
                                    <p class="mb-0">
                                        {{ relocate_CrewName }}
                                    </p>
                                    <v-icon class="mx-1" v-if="input_CrewName !== ''">
                                        mdi-arrow-right
                                    </v-icon>
                                    <p class="mb-0" v-if="input_CrewName !== ''">
                                        {{ input_CrewName }}
                                    </p>
                                </div>
                            </div>

                            <div style="display: flex; flex-direction: row; align-items: start;">
                                <v-icon class="mr-1">mdi-airplane</v-icon>
                                <div class="mr-8" style="display:flex;flex-direction:row;">
                                    <p class="mb-0">
                                        {{ get_AircraftConfigs.filter(aircraft => aircraft.id === relocate_Aircraft)[0].code }}
                                    </p>
                                    <v-icon class="mx-1" v-if="input_Aircraft !== ''">
                                        mdi-arrow-right
                                    </v-icon>
                                    <p class="mb-0" v-if="input_Aircraft !== ''">
                                        {{ get_AircraftConfigs.filter(aircraft => aircraft.id === input_Aircraft)[0].code }}
                                    </p>
                                </div>
                            </div>


                            <div style="display: flex; flex-direction: row; align-items: start;">
                                <v-icon class="mr-1">mdi-map-marker</v-icon>
                                <div style="display:flex;flex-direction:row;">
                                    <p class="mb-0">
                                        {{ get_Bases.filter(base => base.idAirport === relocate_Base)[0].aptCode }}
                                    </p>
                                    <v-icon class="mx-1" v-if="input_Base !== ''">
                                        mdi-arrow-right
                                    </v-icon>
                                    <p class="mb-0" v-if="input_Base !== ''">
                                        {{ get_Bases.filter(base => base.idAirport === input_Base)[0].aptCode }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- <<< Second Leg -->

                    <v-spacer></v-spacer>
                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet"> Close</v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onValidate_Form"> Save</v-btn>
                </v-card-actions>
                <!-- <<< Action Buttons - Bottom -->
            </v-card>
            <!-- <<< Form, Fields -->
        </v-bottom-sheet>

    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';

    import { eventBus } from '../../../../../main';


    export default {
        name: 'CrewsOnAirplaneBottomSheet',

        /* >>> *************************************************************** / /* Props */
        props: {

            value : [Boolean], // 'showSheet'
            editorMode : String, // 'update', 'create', 'relocate'
            crewsOnAirplanePrefillObject : Object // item

		},
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
		data: function() {

			return {
                // >>> ------------------------------------ 'Form Validation Rules'
                valid : false,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || `Field is required`;
                    },

                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },

                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    }
                },
                // >>> ------------------------------------ 'General'
                input_CrewId: null,
                input_CrewName: '',
                input_Aircraft: '',
                input_Base: '',
                input_Remark: '',
                // >>> ------------------------------------ 'Crew Name'
                actualCrewName: '',
                // >>> ------------------------------------ 'Relocate Infos'
                relocate_CrewName: '',
                relocate_Aircraft: '',
                relocate_Base: '',
                relocate_Remark: ''
			};

		}, // eo funtion data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
				'get_AircraftConfigs',
                'get_Countries',
                'get_Bases',
                'get_Bases_Filtered',
                'get_MemberOnCrew'
			]),


			/*******************************************************************
			* sheetShown{}
			*
			* Desc:
			* Note:
			*
			*/
            sheetShown: {

				get() {

                    const me = this;
                    let eventRecord = me.crewsOnAirplanePrefillObject;


                    me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    if (true === me.value) { // we're opening so initialize data

                        // >>> ------------------ reset validation
                        if(this.$refs.form !== undefined) {
                            this.$refs.form.resetValidation();
                        }

                        // >>> ------------------ relocate
                        if (this.editorMode === 'relocate') {
                            if (eventRecord) {
                                this.onAssign_Relocate(eventRecord);
                            }
                        }

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                this.onAssign_Update(eventRecord);
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            this.onAssign_Create();
                        }

                    }

                    return this.value;

                }, // eo function sheetShown get()

				set(value) {

                    const me = this;


                    me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    this.$emit('input', value);

                }, // eo function sheetShown set()

            }, // eo sheetShown{}

        }, // eo computed{}
        /* <<< ****************************************************************/


		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> created');
            eventBus.$on('crewswasupdatedcreated', this.onClick_CloseSheet);

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;

            me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> destroyed');
            eventBus.$off('crewswasupdatedcreated', this.onClick_CloseSheet);

		}, // eo function destroyed()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
		methods: {

            ...mapActions([
                'actn_call_updateCreateCrew'
            ]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate_Form()
            *
            * Desc: Check if Form is valid.
            * Note: used in 'update' and 'create' Mode.
            * Note: Sends 'id' in 'update' Mode...And NO 'id' in 'create' Mode.
            *
            */
            onValidate_Form: function() {

                const me = this;
                let payload = null;


                this.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> onValidate_Form');
                if (this.$refs.form.validate() === true) {
                    payload = {
                        'id': this.editorMode === 'create' || me.editorMode === 'relocate' ? null : +this.input_CrewId, // Important: Watch this!
                        'name': this.input_CrewName,
                        'idAircraft': this.input_Aircraft,
                        'idBase': this.input_Base,
                        'description': this.input_Remark,
                        'crewIds': this.createCrewIdsArray()
                    };

                    this.actn_call_updateCreateCrew({ payload: payload, editorMode: this.editorMode });
                }

            }, // eof onValidate_Form()


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
			onClick_CloseSheet: function() {

                const me = this;


				me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> onClick_CloseSheet');
				this.sheetShown = false;

            }, // eo function onClick_CloseSheet()


            /*******************************************************************
            * Utilities/Helper:
            *******************************************************************/
            /******************************************************************* 'Assign -  Update/Create'
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note:
            *
            * @param {Object} eventRecord ()
            */
            onAssign_Update: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> onAssign_Update');
                Object.assign(me, {
                    // >>> General ------------------------
                    input_CrewId: eventRecord.id,
                    input_CrewName: eventRecord.name,
                    input_Aircraft: eventRecord.idAircraft,
                    input_Base: eventRecord.idBase,
                    input_Remark: eventRecord.description,
                    // >>> ------------------------------------ 'Crew Name'
                    actualCrewName: eventRecord.name
                });

            }, // eof onAssign_Update()


            /*******************************************************************
            * onAssign_Create()
            *
            * Desc: Assign Object in/for 'create' Mode. (Reset)
            * Note:
            *
            */
            onAssign_Create: function() {

                const me = this;


                me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> onAssign_Create');
                Object.assign(me, {
                    // >>> General ------------------------
                    input_CrewId: null,
                    input_CrewName: '',
                    input_Aircraft: '',
                    input_Base: '',
                    input_Remark: '',
                    // >>> ------------------------------------ 'Crew Name'
                    actualCrewName: ''
                });

            }, // eof onAssign_Create()


            /******************************************************************* 'Assign -  Update/Create'
            * onAssign_Relocate()
            *
            * Desc: Assign Object in/for 'reloacte' Mode.
            * Note:
            *
            * @param {Object} eventRecord ()
            */
            onAssign_Relocate: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> onAssign_Relocate');

                Object.assign(me, {
                    // >>> General ------------------------
                    input_CrewId: null,
                    input_CrewName: '',
                    input_Aircraft: '',
                    input_Base: '',
                    input_Remark: '',
                    // >>> ------------------------------------ 'Crew Name'
                    actualCrewName: '',
                    // >>> ------------------------------------ 'Relocate Infos'
                    relocate_CrewName: eventRecord.name,
                    relocate_Aircraft: eventRecord.idAircraft,
                    relocate_Base: eventRecord.idBase,
                    relocate_Remark: eventRecord.description
                });

            }, // eof onAssign_Relocate()


            /******************************************************************* 'Format - Dates'
            * createCrewIdsArray()
            *
            * Desc: Create CrewIds Array for Payload.
            * Note:
            *
            */
            createCrewIdsArray: function() {

                const me = this;
                let crewIds = [];


                me.$toc('>>> views/people/crews/components/core/BottomSheet.vue >>> createCrewIdsArray');
                if(this.editorMode === "update" || me.editorMode === "relocate") {
                    crewIds = this.get_MemberOnCrew.crew.map((member) => member.id);
                }


                return crewIds;

            }, // eo function createCrewIdsArray()

        } // eo methods{}

    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }
</style>

<style>
    .v-input__icon--append .v-icon {
        color: #ab3b7a;
    }

    .theme--light.v-label {
        color: rgba(0, 0, 0, 1);
    }
</style>
